import { Controller } from "@hotwired/stimulus";
import { verifyInterface } from "../utils";

export default class extends Controller {
  static targets = ["out"];
  connect() {
    verifyInterface(this, {
      allTargets: true,
      allValues: true,
    });
    this.updateClock();
    this.updateInterval = setInterval(() => {
      this.updateClock();
    }, 15 * 1000);
  }

  updateClock() {
    const d = new Date();
    this.outTarget.innerText = d.toLocaleDateString("de-DE", {
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    });
  }

  disconnect() {
    clearInterval(this.updateInterval);
  }
}
